import { useState, useEffect, useCallback } from 'react';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'cookieConsent';
const EVENT_NAME = 'cookieConsentUpdated';

export type ConsentStatus = 'accepted' | 'rejected';

/**
 * Get current consent status
 * @param consent - 'accepted' or 'rejected'
 */
export const useConsent = () => {
  const [hasConsent, setHasConsent] = useState(() => {
    return Cookies.get(COOKIE_NAME) === 'accepted';
  });


  useEffect(() => {
    const handleEvent = () => {
      const updatedValue = Cookies.get(COOKIE_NAME) === 'accepted';
      setHasConsent(updatedValue);
    };

    window.addEventListener(EVENT_NAME, handleEvent);

    return () => {
      window.removeEventListener(EVENT_NAME, handleEvent);
    };
  }, []);

  const updateConsent = useCallback((consent: ConsentStatus) => {
    Cookies.set(COOKIE_NAME, consent, { expires: 365 });

    window.dispatchEvent(new Event(EVENT_NAME));
  }, []);

  return { hasConsent, updateConsent };
};
